/*
  Calendar Date Select

  Activates the date select tool for the calendar

  EMITTED EVENTS
    dateSelect (document) Emitted whenever a date shift link is clicked, or a new date is selected, or the Today button is clicked
      detail: {
        el:   the root element of this controller instance,
        date: a Date instance representing the new date selected or shifted to,
        url:  a url to redirect to after a date is selected or shifted to
      }
*/

import { createCustomEvent } from '../../shared/helpers';

export default class extends Controller {
  static targets = ['popUp', 'daterange', 'todayButton'];

  connect() {
    this.element.innerHTML = this.template;
    this.initDateRangeSelect();
  }

  initDateRangeSelect() {
    this.cal = App.DateRangeSelect.init({
      hidePresets: true,
      dateHandler: this.dateSelectHandler.bind(this),
      selector:    ".calendar--calendar--component .daterange"
    });
    this.hideOrShowTodayBtn();
  }

  dateSelectHandler(date) {
    if (!this.isDisabled) {
      if (document.hasDateSelectListener) {
        document.dispatchEvent(createCustomEvent('dateSelect', this.element, {
          date: date.toDate(),
          url:  this.url ? this.url.replace('DATE', moment(date).format('YYYY-MM-DD')) : null
        }));
      } else if(this.url) {
        document.location = this.url.replace('DATE', moment(date).format('YYYY-MM-DD'));
      }
    }
  }

  shiftBack(event) {
    event && event.preventDefault();
    this.shiftDate('subtract');
  }

  shiftForward(event) {
    event && event.preventDefault();
    this.shiftDate('add');
  }

  shiftDate(shiftOp) {
    const dateRangeObj = this.dateRangeObj;
    this.dateSelectHandler(this.mDate[shiftOp](dateRangeObj.number, dateRangeObj.unit));
  }

  goToToday(event) {
    event && event.preventDefault();
    this.dateSelectHandler(moment());
  }

  togglePopUp(event) {
    event && event.preventDefault();
    if (!this.isDisabled) {
      this.popUpTarget.classList.toggle('open');
      if (this.popUpTarget.classList.contains('open')) this.openDateRange(100);
    }
  }

  openDateRange(timeout = 0) {
    setTimeout(() => this.element.querySelector('.dr-date').click(), timeout);
  }

  hideOrShowTodayBtn() {
    if (this.isRangeForToday) {
      this.todayButtonTarget.classList.remove('show-btn');
    } else {
      this.todayButtonTarget.classList.add('show-btn');
    }
  }

  get template() {
    return `
      <div class="calendar-date-select--component${this.isDisabled ? ' is-disabled' : ''}">
        <div class="daterange-shift-links">
          <a class="daterange-shift-link" data-action="${this.identifier}#shiftBack"><i class="fa fa-chevron-left"></i></a>
          <a class="daterange-shift-link" data-action="${this.identifier}#shiftForward"><i class="fa fa-chevron-right"></i></a>
        </div>
        <button data-action="${this.identifier}#togglePopUp" class="date-select-toggle-btn date-select-btn btn btn-gray">
          ${this.dateRangeText}
        </button>
        <button data-${this.identifier}-target="todayButton"
          data-action="${this.identifier}#goToToday"
          class="date-select-today-btn date-select-btn btn btn-gray">
          Today
        </button>
        <div data-${this.identifier}-target="popUp" class="date-select-popup">
          <input type="hidden" name="range" value="${this.view}" />
          <input type="hidden" name="data" value="${this.date}" />
          <div class="daterange daterange--single"
            id="data-select-input"
            data-date="${this.date}"
            data-start-date="${this.mDate.subtract(10, 'years')}"
            data-end-date="${this.mDate.add(10, 'years')}"
            data-${this.identifier}-target="daterange">
          </div>
        </div>
      </div>
    `;
  }

  get date() {
    return this.data.get('date');
  }

  get mDate() {
    return moment(this.date);
  }

  get isRangeForToday() {
    return this.mDate.isSame(moment(), this.view === 'month' ? 'month' : 'week');
  }

  get view() {
    return this.data.get('view');
  }

  get url() {
    return this.data.get('url');
  }

  get hideWeekends() {
    return this.data.has('hide-weekends') && this.data.get('hide-weekends') !== 'false' && this.data.get('hide-weekends') !== false;
  }

  get isDisabled() {
    return this.data.has('is-disabled') && this.data.get('is-disabled') !== 'false' && this.data.get('disabled') !== false;
  }

  get dateRangeText() {
    if (this.view === 'month') return this.mDate.format('MMMM YYYY');
    let firstDate, secondDate;
    firstDate = this.mDate.startOf('week');
    secondDate = this.mDate.endOf('week');
    if (this.hideWeekends) {
      firstDate = firstDate.add(1, 'day');
      secondDate = secondDate.subtract(1, 'day');
    }
    if (this.view === 'twoweek') {
      secondDate = secondDate.add(1, 'week');
    }
    const secondFormat = firstDate.isBefore(secondDate, 'month') ? 'MMM D' : 'D';
    return `${firstDate.format('MMM D')} - ${secondDate.format(secondFormat)}`;
  }

  get dateRangeObj() {
    switch(this.view) {
      case 'month':
        return { unit: 'month', number: 1 };
      case 'twoweek':
        return { unit: 'week', number: 2 };
      default:
        return { unit: 'week', number: 1 };
    }
  }
}



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/calendar-date-select-controller.js